import React from "react";
import styles from "./WhyResume.module.css";
import visuals from "../../../Images/selectedresume.svg"; // your single SVG

const SmartResume = () => {
  return (
    <section className={styles.smartResume}>
      <h2>
        Why Recruiters Love AI <br />
        Resume Screening
      </h2>
      <div className={styles.waves}>
        <div className={styles.container}>
          {/* Left Side: Text */}
          <div className={styles.textContent}>
            <ul className={styles.steps}>
              <li>
                <strong>Cut manual resume review time by up to 80%</strong>
              </li>
              <li>
                <strong>Identify top talent faster with AI scoring</strong>
              </li>
              <li>
                <strong>Reduce human bias in candidate evaluation</strong>
              </li>
              <li>
                <strong>Automate shortlisting and candidate filtering</strong>
              </li>
              <li>
                <strong>Gain insights from analytics for smarter hiring</strong>
              </li>
              <li>
                <strong>Improve overall recruitment efficiency and ROI</strong>
              </li>
            </ul>
          </div>

          {/* Right Side: SVG Illustration */}
          <div className={styles.visuals}>
            <img src={visuals} alt="Resume screening process illustration" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SmartResume;
